// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .ep-confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.15s ease-out;
}
:host .ep-confirm-dialog {
  background: var(--ods-color-white, #fff);
  border-radius: 0.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  min-width: 22rem;
  max-width: 36rem;
  width: auto;
  overflow: hidden;
  animation: slideIn 0.15s ease-out;
}
:host .ep-confirm-dialog__header {
  padding: 1rem 1.25rem 0.5rem;
  border-bottom: 1px solid var(--ods-color-gray-20, #e0e0e0);
}
:host .ep-confirm-dialog__title {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--ods-color-purple-60, #5c2d91);
}
:host .ep-confirm-dialog__body {
  padding: 1rem 1.25rem;
}
:host .ep-confirm-dialog__message {
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--ods-color-gray-80, #333);
  white-space: pre-line;
}
:host .ep-confirm-dialog__footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 0.75rem 1.25rem;
  border-top: 1px solid var(--ods-color-gray-20, #e0e0e0);
}
:host .ep-confirm-dialog__btn {
  border: none;
  border-radius: 0.375rem;
  padding: 0.5rem 1.25rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
}
:host .ep-confirm-dialog__btn--confirm {
  background-color: var(--ods-color-purple-60, #5c2d91);
  color: var(--ods-color-white, #fff);
}
:host .ep-confirm-dialog__btn--confirm:hover {
  background-color: var(--ods-color-purple-80, #4a2275);
}
:host .ep-confirm-dialog__btn--confirm:focus-visible {
  outline: 2px solid var(--ods-color-purple-60, #5c2d91);
  outline-offset: 2px;
}
:host .ep-confirm-dialog__btn--cancel {
  background-color: var(--ods-color-white, #fff);
  color: var(--ods-color-gray-80, #333);
  border: 1px solid var(--ods-color-gray-40, #bbb);
}
:host .ep-confirm-dialog__btn--cancel:hover {
  background-color: var(--ods-color-gray-5, #f5f5f5);
}
:host .ep-confirm-dialog__btn--cancel:focus-visible {
  outline: 2px solid var(--ods-color-purple-60, #5c2d91);
  outline-offset: 2px;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideIn {
  from {
    transform: translateY(-12px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/ep-confirm-dialog/ep-confirm-dialog.component.scss"],"names":[],"mappings":"AACE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;AAAJ;AAGE;EACE,wCAAA;EACA,qBAAA;EACA,yCAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;AADJ;AAGI;EACE,4BAAA;EACA,0DAAA;AADN;AAII;EACE,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;AAFN;AAKI;EACE,qBAAA;AAHN;AAMI;EACE,SAAA;EACA,oBAAA;EACA,gBAAA;EACA,qCAAA;EACA,qBAAA;AAJN;AAOI;EACE,aAAA;EACA,yBAAA;EACA,YAAA;EACA,wBAAA;EACA,uDAAA;AALN;AAQI;EACE,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,8DACE;AAPR;AAUM;EACE,qDAAA;EACA,mCAAA;AARR;AAUQ;EACE,qDAAA;AARV;AAWQ;EACE,sDAAA;EACA,mBAAA;AATV;AAaM;EACE,8CAAA;EACA,qCAAA;EACA,gDAAA;AAXR;AAaQ;EACE,kDAAA;AAXV;AAcQ;EACE,sDAAA;EACA,mBAAA;AAZV;AAkBE;EACE;IACE,UAAA;EAhBJ;EAkBE;IACE,UAAA;EAhBJ;AACF;AAmBE;EACE;IACE,4BAAA;IACA,UAAA;EAjBJ;EAmBE;IACE,wBAAA;IACA,UAAA;EAjBJ;AACF","sourcesContent":[":host {\n  .ep-confirm-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.45);\n    z-index: 10000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    animation: fadeIn 0.15s ease-out;\n  }\n\n  .ep-confirm-dialog {\n    background: var(--ods-color-white, #fff);\n    border-radius: 0.5rem;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n    min-width: 22rem;\n    max-width: 36rem;\n    width: auto;\n    overflow: hidden;\n    animation: slideIn 0.15s ease-out;\n\n    &__header {\n      padding: 1rem 1.25rem 0.5rem;\n      border-bottom: 1px solid var(--ods-color-gray-20, #e0e0e0);\n    }\n\n    &__title {\n      margin: 0;\n      font-size: 1.125rem;\n      font-weight: 600;\n      color: var(--ods-color-purple-60, #5c2d91);\n    }\n\n    &__body {\n      padding: 1rem 1.25rem;\n    }\n\n    &__message {\n      margin: 0;\n      font-size: 0.9375rem;\n      line-height: 1.5;\n      color: var(--ods-color-gray-80, #333);\n      white-space: pre-line;\n    }\n\n    &__footer {\n      display: flex;\n      justify-content: flex-end;\n      gap: 0.75rem;\n      padding: 0.75rem 1.25rem;\n      border-top: 1px solid var(--ods-color-gray-20, #e0e0e0);\n    }\n\n    &__btn {\n      border: none;\n      border-radius: 0.375rem;\n      padding: 0.5rem 1.25rem;\n      font-size: 0.875rem;\n      font-weight: 600;\n      cursor: pointer;\n      transition:\n        background-color 0.15s ease,\n        box-shadow 0.15s ease;\n\n      &--confirm {\n        background-color: var(--ods-color-purple-60, #5c2d91);\n        color: var(--ods-color-white, #fff);\n\n        &:hover {\n          background-color: var(--ods-color-purple-80, #4a2275);\n        }\n\n        &:focus-visible {\n          outline: 2px solid var(--ods-color-purple-60, #5c2d91);\n          outline-offset: 2px;\n        }\n      }\n\n      &--cancel {\n        background-color: var(--ods-color-white, #fff);\n        color: var(--ods-color-gray-80, #333);\n        border: 1px solid var(--ods-color-gray-40, #bbb);\n\n        &:hover {\n          background-color: var(--ods-color-gray-5, #f5f5f5);\n        }\n\n        &:focus-visible {\n          outline: 2px solid var(--ods-color-purple-60, #5c2d91);\n          outline-offset: 2px;\n        }\n      }\n    }\n  }\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  @keyframes slideIn {\n    from {\n      transform: translateY(-12px);\n      opacity: 0;\n    }\n    to {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
